import { applyBranding, getProductUrlBasedOnBranding } from '@dashboard/ui';
import { environment as coachBotEnvironment } from '../../../alpha-coach-bot/src/environments/environment.production';
import aws_exports from '../aws-exports';

applyBranding();

export const environment = {
  ...coachBotEnvironment,
  ...aws_exports,
  productUrl: getProductUrlBasedOnBranding(),
  payments: {
    stripe: {
      publicKey:
        'pk_live_51K2eb6G3m7zXBg5pYr9uAO0RZfcZQXO7R0mI1qKbzwJF9ucIeSIjtv9eAS3Iiv1V16cZ0Ibg2Ncudb0kpHwXQ2mo00C6e86Q96',
      monthlyPriceId: 'price_1Q0m7pG3m7zXBg5pOSjnPZ3v',
      yearlyPriceId: 'price_1PslnfG3m7zXBg5py7LAKF6N',
    },
  },
};
